var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 1.5C3.67406 1.5 3.0296 1.6955 2.48143 2.06177C1.93327 2.42804 1.50603 2.94863 1.25374 3.55772C1.00144 4.16681 0.935433 4.83703 1.06405 5.48363C1.19267 6.13024 1.51014 6.72418 1.97631 7.19036C2.44249 7.65653 3.03643 7.974 3.68303 8.10262C4.32964 8.23124 4.99986 8.16522 5.60895 7.91293C6.21803 7.66064 6.73863 7.2334 7.1049 6.68523C7.47117 6.13707 7.66667 5.4926 7.66667 4.83333C7.66667 3.94928 7.31548 3.10143 6.69036 2.47631C6.06524 1.85119 5.21739 1.5 4.33333 1.5ZM12.6667 16.5C13.3259 16.5 13.9704 16.3045 14.5186 15.9382C15.0667 15.572 15.494 15.0514 15.7463 14.4423C15.9986 13.8332 16.0646 13.163 15.936 12.5164C15.8073 11.8698 15.4899 11.2758 15.0237 10.8096C14.5575 10.3435 13.9636 10.026 13.317 9.89738C12.6704 9.76876 12.0001 9.83478 11.3911 10.0871C10.782 10.3394 10.2614 10.7666 9.8951 11.3148C9.52883 11.8629 9.33333 12.5074 9.33333 13.1667C9.33333 14.0507 9.68452 14.8986 10.3096 15.5237C10.9348 16.1488 11.7826 16.5 12.6667 16.5Z",
    fill: "#005F73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6417 2.69141C11.6108 3.01749 12.4918 3.56208 13.2167 4.28307C13.9849 5.0527 14.5566 5.99594 14.8834 7.03307",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 6.34154L14.8833 7.04154L15.5833 5.5332",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 10.9668C2.45181 12.0039 3.02347 12.9472 3.79167 13.7168C4.51659 14.4378 5.39764 14.9824 6.36667 15.3085",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62496 11.658L2.11663 10.958L1.41663 12.4663",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 1.5C3.67406 1.5 3.0296 1.6955 2.48143 2.06177C1.93327 2.42804 1.50603 2.94863 1.25374 3.55772C1.00144 4.16681 0.935433 4.83703 1.06405 5.48363C1.19267 6.13024 1.51014 6.72418 1.97631 7.19036C2.44249 7.65653 3.03643 7.974 3.68303 8.10262C4.32964 8.23124 4.99986 8.16522 5.60895 7.91293C6.21803 7.66064 6.73863 7.2334 7.1049 6.68523C7.47117 6.13707 7.66667 5.4926 7.66667 4.83333C7.66667 3.94928 7.31548 3.10143 6.69036 2.47631C6.06524 1.85119 5.21739 1.5 4.33333 1.5ZM12.6667 16.5C13.3259 16.5 13.9704 16.3045 14.5186 15.9382C15.0667 15.572 15.494 15.0514 15.7463 14.4423C15.9986 13.8332 16.0646 13.163 15.936 12.5164C15.8073 11.8698 15.4899 11.2758 15.0237 10.8096C14.5575 10.3435 13.9636 10.026 13.317 9.89738C12.6704 9.76876 12.0001 9.83478 11.3911 10.0871C10.782 10.3394 10.2614 10.7666 9.8951 11.3148C9.52883 11.8629 9.33333 12.5074 9.33333 13.1667C9.33333 14.0507 9.68452 14.8986 10.3096 15.5237C10.9348 16.1488 11.7826 16.5 12.6667 16.5Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.da0377a51fceca6b4af45038c7a2eebf.svg";
export { ForwardRef as ReactComponent };